import { Col, Container, Form, Offcanvas, Row } from "react-bootstrap";

const repeatOptions = Array.from({ length: 11 }, (_, index) => index);

const ManagementFilterCanvas = ({
  Show,
  Hide,
  Title,
  siteList = [],
  subjectList = [],
  eventList = [],
  siteId,
  setSiteId,
  subjectId,
  setSubjectId,
  eventId,
  setEventId,
  timePointId,
  setTimePointId,
  formList = [],
  formId,
  setFormId,
  repeatEvent,
  setRepeatEvent,
  repeatForm,
  setRepeatForm,
  statusOptions,
  status,
  setStatus,
  answeredOptions,
  answered,
  setAnswered,
  typeOptions,
  type,
  setType,
  onApply,
  onReset,
}) => {
  const eventValue = eventId ? `${eventId}|${timePointId || ""}` : "";
  const hasFilter = siteId || subjectId || eventId || type || formId || repeatEvent !== "" || repeatForm !== "" || answered || (status && status !== "ALL");

  const handleEventChange = (e) => {
    const [newEventId = "", newTimePointId = ""] = e.target.value.split("|");
    setEventId(newEventId);
    setTimePointId(newTimePointId);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title} by selection</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Container fluid>
          <Row className="mb-2">
            <Form.Group as={Col} md={4} className="text-end">
              <Form.Label>Site:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Form.Select
                value={siteId || ""}
                onChange={(e) => {
                  setSiteId(e.target.value);
                  setSubjectId("");
                }}
              >
                <option value="">Select Site</option>
                {siteList?.map((siteData) => (
                  <option key={siteData?.siteId} value={siteData?.siteId}>
                    {siteData?.row?.SITEID}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} md={4} className="text-end">
              <Form.Label>Subject:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Form.Select
                value={subjectId || ""}
                disabled={!siteId}
                onChange={(e) => setSubjectId(e.target.value)}
              >
                <option value="">{siteId ? "Select Subject" : "Select Site first"}</option>
                {subjectList?.map((subjectData) => (
                  <option key={subjectData?.subjectId} value={subjectData?.subjectId}>
                    {subjectData?.row?.SUBJECTID || subjectData?.row?.RANDOMNUMBER || subjectData?.row?.SCREENID}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} md={4} className="text-end">
              <Form.Label>Event:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Form.Select value={eventValue} onChange={handleEventChange}>
                <option value="">Select Event</option>
                {eventList?.map((eventData) => {
                  const timePointUniqueId = eventData?.row?.TIMEPOINTUNIQUEID || "";
                  return (
                    <option
                      key={`${eventData?.eventId}|${timePointUniqueId}`}
                      value={`${eventData?.eventId}|${timePointUniqueId}`}
                    >
                      {eventData?.row?.EVENTID} {timePointUniqueId && `(${eventData?.row?.TIMEPOINTID})`}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} md={4} className="text-end">
              <Form.Label>Repeat Event:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Form.Select value={repeatEvent} onChange={(e) => setRepeatEvent(e.target.value)}>
                <option value="">Select Repeat Event</option>
                {repeatOptions.map((number) => (
                  <option key={number} value={number}>
                    {number}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} md={4} className="text-end">
              <Form.Label>Form:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Form.Select value={formId || ""} onChange={(e) => setFormId(e.target.value)}>
                <option value="">Select Form</option>
                {formList?.map((form) => (
                  <option key={form?.formId} value={form?.formId}>
                    {form?.formName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} md={4} className="text-end">
              <Form.Label>Repeat Form:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md={8}>
              <Form.Select value={repeatForm} onChange={(e) => setRepeatForm(e.target.value)}>
                <option value="">Select Repeat Form</option>
                {repeatOptions.map((number) => (
                  <option key={number} value={number}>
                    {number}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          {statusOptions && (
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>Status:</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select value={status || "ALL"} onChange={(e) => setStatus(e.target.value)}>
                  {statusOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
          )}
          {answeredOptions && (
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>Answered:</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select value={answered || ""} onChange={(e) => setAnswered(e.target.value)}>
                  <option value="">Select Answered</option>
                  {answeredOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
          )}
          {typeOptions && (
            <Row className="mb-2">
              <Form.Group as={Col} md={4} className="text-end">
                <Form.Label>Type:</Form.Label>
              </Form.Group>
              <Form.Group as={Col} md={8}>
                <Form.Select value={type || ""} onChange={(e) => setType(e.target.value)}>
                  <option value="">Select Type</option>
                  {typeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
          )}
        </Container>
      </Offcanvas.Body>
      <div className="border-top p-2 bg-light hstack justify-content-end gap-2">
        <button onClick={onReset} disabled={!hasFilter} className="updateProfile">
          Reset
        </button>
        <button
          onClick={() => {
            onApply();
            Hide();
          }}
          className="updateProfile"
        >
          Filter selection
        </button>
      </div>
    </Offcanvas>
  );
};

export default ManagementFilterCanvas;
